// extracted by mini-css-extract-plugin
module.exports = {"label":"style-module__label___TNtou","required":"style-module__required___q2Eew"};